import { jsx as _jsx } from "react/jsx-runtime";
function ArrowLeftArrowRight({ className, size = 24, }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { d: "M7 20l-5-5 5-5 1.4 1.425L5.825 14H13v2H5.825L8.4 18.575 7 20zm10-6l-1.4-1.425L18.175 10H11V8h7.175L15.6 5.425 17 4l5 5-5 5z" }) }));
}
export default ArrowLeftArrowRight;
